import { Order } from "@/services/backend/vbs/orders/types/order";
import {
  updateVbsOrderCache,
  useVbsOrderResetReferenceNumberMutation,
  useVbsOrderPatchMutation,
} from "@/services/backend/vbs/orders/api/order-api";
import { ReferenceNumberField } from "@/services/backend/documents/components/reference-number-field";
import { isImmutable } from "@/services/backend/documents/lib/document-state";

/**
 * OrderReferenceNumberField edits the reference number of an order.
 */
export function OrderReferenceNumberField({
  order,
  disabled = false,
  className,
}: {
  order: Order;
  disabled?: boolean;
  className?: string;
}) {
  const patchReferenceNumber = useVbsOrderPatchMutation();
  const resetReferenceNumber = useVbsOrderResetReferenceNumberMutation();

  return (
    <div className={className}>
      <ReferenceNumberField
        data={order}
        updateCache={updateVbsOrderCache}
        patchMutation={patchReferenceNumber}
        resetMutation={resetReferenceNumber}
        disabled={disabled || isImmutable(order)}
      />
    </div>
  );
}
